module.exports = __webpack_public_path__ + "static/media/function_hk.f1beb35f.png";